import { render, staticRenderFns } from "./Receivable.vue?vue&type=template&id=c379508a&scoped=true"
import script from "./Receivable.vue?vue&type=script&lang=js"
export * from "./Receivable.vue?vue&type=script&lang=js"
import style0 from "./Receivable.vue?vue&type=style&index=0&id=c379508a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c379508a",
  null
  
)

export default component.exports